import React from 'react';
interface AvatarProps {
  src?: string;
  alt?: string;
  fallback: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  status?: 'online' | 'offline' | 'busy';
  className?: string;
}
export function Avatar({
  src,
  alt,
  fallback,
  size = 'md',
  status,
  className = ''
}: AvatarProps) {
  const sizes = {
    xs: 'h-6 w-6 text-[10px]',
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-16 w-16 text-lg'
  };
  const statusColors = {
    online: 'bg-emerald-500',
    offline: 'bg-slate-500',
    busy: 'bg-red-500'
  };
  return <div className={`relative inline-block ${className}`} data-id="element-178">
      <div className={`${sizes[size]} rounded-full overflow-hidden bg-slate-700 flex items-center justify-center ring-2 ring-white/10`} data-id="element-179">
        {src ? <img src={src} alt={alt || fallback} className="h-full w-full object-cover" data-id="element-180" /> : <span className="font-medium text-white" data-id="element-181">
            {fallback.substring(0, 2).toUpperCase()}
          </span>}
      </div>
      {status && <span className={`absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-background ${statusColors[status]}`} data-id="element-182" />}
    </div>;
}